import { useQuery } from '@apollo/client';
import { Navigate, useParams } from 'react-router-dom';
import { LoadingPane } from '~/components/loading-pane';
import { useAppContext } from '~/contexts';
import { useLink } from '~/hooks/link';
import { ShowDetailView } from './ShowDetailView';
import { ShowDetailViewDocument } from './ShowDetailView.generated';

export const ShowDetailPage = () => {
  const { currentNetwork } = useAppContext();
  const params = useParams<{ showId: string; showFolderId: string }>();
  const showFolderId = Number(params.showFolderId);
  const showId = parseInt(params.showId ?? '');
  const { data, loading } = useQuery(ShowDetailViewDocument, {
    variables: { networkId: currentNetwork.id, showId, showFolderId },
  });

  const link = useLink();

  if (!loading && !data?.network?.show) return <Navigate to={link('/not-found')} replace />;

  const show = data?.network?.show;
  const showFolder = data?.network?.showFolder;

  return (
    <LoadingPane in={loading && !data} size={80} thickness={4}>
      {show && showFolder && <ShowDetailView show={show} showFolder={showFolder} />}
    </LoadingPane>
  );
};
